const moment = require('moment')

export const convertDate = date => moment(date)
